import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import CoreComponent from "./CoreComponent";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import { IObject, IBlacklist } from "../interfaces";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { arrayToFormData } from "../utils/functions";
import BlacklistModal from "../components/BlacklistModal";

interface IState {
    objects: IBlacklist[];
    model: IBlacklist;
    limit: number;
    pagination: any;
    ids: number[];
    type: string;
    sort: string;
    isLoading: boolean;
    isOpen: boolean;
    currentPage: number;
}

class Blacklist extends CoreComponent<any, any> {
    state: IState = {
        objects: [],
        limit: 30,
        pagination: null,
        model: null,
        ids: [],
        type: "",
        sort: "",
        isLoading: true,
        isOpen: false,
        currentPage: 1,
    };

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    async componentWillMount() {
        this.loadObjects();
    }

    async loadObjects() {
        this.setState(
            {
                isLoading: true,
            },
            async () => {
                let url = null;
                let limit = this.state.limit * this.state.currentPage;

                url = `${config.api}/blacklist?limit=${limit}`;

                if (this.state.sort) {
                    url += `&sort=${this.state.sort}`;
                }

                if (this.state.type) {
                    url += `&type=${this.state.type}`;
                }

                let res = await Axios.get(url);

                if (!this.isUnmounted) {
                    this.setState({
                        objects: res.data.models,
                        pagination: res.data.pagination,
                        isLoading: false,
                    });
                }
            }
        );
    }

    setOrder(sort: string) {
        this.setState(
            {
                type:
                    this.state.sort != sort
                        ? "asc"
                        : this.state.type == "asc"
                            ? "desc"
                            : "asc",
                sort,
            },
            () => {
                this.loadObjects();
            }
        );
    }

    showMore() {
        this.setState(
            {
                currentPage: this.state.currentPage + 1,
            },
            () => {
                this.loadObjects();
            }
        );
    }

    async delete() {
        if (confirm("Вы уверены?")) {
            if (this.state.ids.length > 0) {
                let response: AxiosResponse = await Axios.post(
                    `${config.api}/blacklist/delete`,
                    arrayToFormData({ id: this.state.ids })
                );

                if (response.data && response.data.length > 0)
                    this.setState({
                        objects: this.state.objects.filter(
                            (object: IObject) =>
                                !response.data.includes(object.id.toString())
                        ),
                        ids: [],
                    });

                toast("Объекты удалены: " + response.data.length, {
                    type: "success",
                });
            } else {
                toast("Выберите объектов", { type: "error" });
            }
        }
    }

    async move() {
        if (confirm("Вы уверены?")) {
            if (this.state.ids.length > 0) {
                let response: AxiosResponse = await Axios.post(
                    `${config.api}/blacklist/move`,
                    arrayToFormData({ id: this.state.ids })
                );

                if (response.data && response.data.length > 0)
                    this.setState({
                        objects: this.state.objects.filter(
                            (object: IObject) =>
                                !response.data.includes(object.id.toString())
                        ),
                        ids: [],
                    });

                toast("Объекты перемещены: " + response.data.length, {
                    type: "success",
                });
            } else {
                toast("Выберите объектов", { type: "error" });
            }
        }
    }

    handleModal() {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            () => {
                this.loadObjects();
            }
        );
    }

    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div>
                <BlacklistModal
                    isOpen={this.state.isOpen}
                    handleModal={this.handleModal}
                    model={this.state.model}
                />
                <div className="crm-holders black-list">
                    <div className="wrapper" style={{ maxWidth: "1370px" }}>
                        <NavLink className="crm-holders__back" to="/admin">
                            Назад
                        </NavLink>
                        <span className="crm-holders__title">
                            Чёрный список
                        </span>

                        <div className="crm-holders__headline">
                            <div style={{ display: "flex" }}>
                                <a
                                    className="crm-button mr-3"
                                    role="button"
                                    onClick={() => {
                                        this.handleModal();
                                    }}
                                >
                                    Добавить
                                </a>
                                <a
                                    className="crm-button mr-3"
                                    role="button"
                                    onClick={() => {
                                        this.move();
                                    }}
                                >
                                    Переместить в несортированные
                                </a>
                                <a
                                    role="button"
                                    onClick={() => {
                                        this.delete();
                                    }}
                                    style={{ margin: "0", marginRight: "15px" }}
                                    className="btn-del"
                                >
                                    Удалить
                                </a>
                            </div>
                        </div>

                        <div className="crm-list">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                onChange={() => {
                                                    if (
                                                        this.state.ids.length !=
                                                        this.state.objects
                                                            .length
                                                    ) {
                                                        this.setState({
                                                            ids: this.state.objects.map(
                                                                (
                                                                    holder: IObject
                                                                ) => holder.id
                                                            ),
                                                        });
                                                    } else {
                                                        this.setState({
                                                            ids: [],
                                                        });
                                                    }
                                                }}
                                                checked={
                                                    this.state.ids.length ==
                                                    this.state.objects.length
                                                }
                                            />
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("id");
                                                }}
                                            >
                                                ID
                                            </a>
                                        </th>

                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("name");
                                                }}
                                            >
                                                Название
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>

                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("created_at");
                                                }}
                                            >
                                                Дата
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("youtube_id");
                                                }}
                                            >
                                                Source ID{" "}
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <img
                                                src="img/crm-youtube.svg"
                                                alt=""
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!this.state.isLoading &&
                                        this.state.objects.length == 0 && (
                                            <tr>
                                                <td colSpan={11}>
                                                    {t("Ничего не найдено")}
                                                </td>
                                            </tr>
                                        )}
                                    {this.state.isLoading && (
                                        <tr>
                                            <td colSpan={11}>
                                                {t("Загрузка данных")}
                                            </td>
                                        </tr>
                                    )}
                                    {this.state.objects.map(
                                        (object: IBlacklist, i: number) => {
                                            return (
                                                <tr key={i}>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={
                                                                !!this.state.ids.find(
                                                                    (
                                                                        id: number
                                                                    ) =>
                                                                        id ==
                                                                        object.id
                                                                )
                                                            }
                                                            onChange={(
                                                                e: any
                                                            ) => {
                                                                if (
                                                                    e.target
                                                                        .checked
                                                                ) {
                                                                    this.setState(
                                                                        {
                                                                            ids: [
                                                                                ...this
                                                                                    .state
                                                                                    .ids,
                                                                                object.id,
                                                                            ],
                                                                        }
                                                                    );
                                                                } else {
                                                                    this.setState(
                                                                        {
                                                                            ids: this.state.ids.filter(
                                                                                (
                                                                                    id: number
                                                                                ) =>
                                                                                    id !=
                                                                                    object.id
                                                                            ),
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{object.id}</td>

                                                    <td>
                                                        {object.name}
                                                        <a
                                                            role="button"
                                                            className="d-inline ml-2"
                                                            onClick={() => {
                                                                this.setState(
                                                                    {
                                                                        model: object,
                                                                    },
                                                                    () => {
                                                                        this.handleModal();
                                                                    }
                                                                );
                                                            }}
                                                        >
                                                            <img
                                                                src="/img/Icon awesome-edit.svg"
                                                                style={{
                                                                    width: "14px",
                                                                }}
                                                            />{" "}
                                                        </a>
                                                    </td>
                                                    <td>{object.created_at}</td>
                                                    <td>{object.youtube_id}</td>
                                                    <td>
                                                        {object.youtube_id.startsWith("103") ? <img src="img/ico1.svg" width="15" alt="" /> :
                                                            (object.youtube_id.startsWith("A") ? <img src="img/ico2.svg" width="15" alt="" /> :
                                                                <a href={"https://youtu.be/" + object.youtube_id} target="_blink">
                                                                    <img src="img/crm-youtube.svg" alt="" />
                                                                </a>)}
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )}
                                </tbody>
                            </table>
                            <div className="text-center p-3">
                                {this.state.objects.length > 0 && this.state.objects.length < this.state.pagination?.totalCount && (
                                    <a
                                        role="button"
                                        className="spec-color fs-12"
                                        onClick={() => {
                                            this.showMore();
                                        }}
                                    >
                                        Показать ещё...
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth,
    };
})(withTranslation()(Blacklist));
